module.exports = __webpack_public_path__ + "static/media/webinar.74b28d77.png";